let initialSectionHash = "";

export const captureInitialSectionHash = (hash) => {
  const sectionId = hash.replace(/^#/, "");

  initialSectionHash = /^[A-Za-z][\w:-]*$/.test(sectionId) ? sectionId : "";
};

export const getInitialSectionHash = () => initialSectionHash;

export const clearInitialSectionHash = () => {
  initialSectionHash = "";
};
